export default __webpack_public_path__ + "static/media/custom.75ce11f6.png";